<template>

    <!-- Loading Modal beginning -->
    <div class="modal" v-bind:class="{ 'is-active' : isLoading}">
        <!--<div class="modal-background"></div>-->
        <div class="modal-content">
            <p class="image">
                <img class="brand" src="../../assets/loading.gif" alt="" width="80px">
            </p>
        </div>
    </div>
    <!-- End of Loading Modal -->

</template>

<script>

export default {

  data () {
    return {
      showLoading: false
    }
  },

  created () {
    Event.$on('showLoading', () => {
      this.showLoading = true
    })

    Event.$on('closeLoading', () => {
      this.showLoading = false
    })
  },

  computed: {
    isLoading () {
      return this.showLoading
    }
  }
}
</script>

<style scoped>
    .image img {
        width: 150px;
        display: block;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/Loading.vue